<template>
  <!-- <div class="app-wrapper" :class="{hideSidebar:!sidebar}"> -->
  <div class="app-wrapper">
    <sr-header @changeNav="changeNav"></sr-header>
    <sr-sider ref="srSider" class="sidebar-container"></sr-sider>
    <el-container>
      <el-main class="main-container">
        <sr-main></sr-main>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import { SrHeader, SrSider, SrMain } from './components'

  export default {
    name: 'layout',
    components: { SrHeader, SrSider, SrMain },
    data () {
      return {
      }
    },
    methods: {
      // header切换导航菜单
      changeNav(navItem) {
        // console.log('切换导航菜单-navItem', navItem);
        // 得到header选中的菜单后，传递给子组件sider
        this.$refs.srSider.changeMenu(navItem);
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    // min-width: 1000px;
    // min-width: 850px;
    min-width: 830px;

    // display: flex;
    // flex-flow: column;



    .sidebar-container {
			// transition: width 0.1s ease-out;
			width: 180px;
			position: fixed;
			top: 48px;
			bottom: 0;
			left: 0;
			overflow-y: auto;
 			&::-webkit-scrollbar {display:none}
		}

    .main-container {
      width: auto;
      // min-height: 100%;

      margin-top: 48px;
      margin-left: 180px;

      padding: 13px 10px 10px;
      // background-color: #63676b;
    }
  }
</style>
